var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "container", class: _vm.classList },
    [
      _vm.label
        ? _c("t-label", {
            staticClass: "t-select__label",
            attrs: { label: _vm.label, required: _vm.required },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.native
        ? [
            _c(
              "div",
              {
                staticClass: "t-select__trigger",
                attrs: { tabindex: "0" },
                on: {
                  click: function ($event) {
                    !(_vm.readonly || _vm.disabled) &&
                      _vm.toggleDropdown($event)
                  },
                  keydown: _vm.toggleDropdown,
                },
              },
              [
                !_vm.$slots.trigger
                  ? _c(
                      "span",
                      {
                        staticClass: "t-select__value",
                        class: [
                          {
                            "t-select__placeholder":
                              _vm.placeholder == _vm.internalPlaceholder,
                          },
                          { "t-truncate": _vm.truncate },
                        ],
                      },
                      [_vm._v(_vm._s(_vm.internalPlaceholder))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("trigger"),
              ],
              2
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "popup-in", mode: "out-in" } }, [
              _vm.showDropdown
                ? _c("div", { key: "popover", staticClass: "t-select__wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "t-select__content",
                        attrs: { role: "listbox" },
                      },
                      [
                        !_vm.$slots.options
                          ? [
                              _vm.areOptionsEmpty
                                ? _c(
                                    "div",
                                    { staticClass: "t-select__empty" },
                                    [
                                      _vm._v(
                                        "\n              No data found\n            "
                                      ),
                                    ]
                                  )
                                : _vm._l(
                                    _vm.filteredOptions,
                                    function (option, index) {
                                      return _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: option.tooltip,
                                              expression: "option.tooltip",
                                            },
                                          ],
                                          key: `dd_${index}`,
                                          ref: "x1",
                                          refInFor: true,
                                          staticClass: "t-select__item",
                                          class: [
                                            {
                                              "t-select__item--disabled":
                                                option.disabled,
                                            },
                                            {
                                              "t-select__item--focus":
                                                option.value == _vm.value,
                                            },
                                          ],
                                          attrs: {
                                            role: "option",
                                            tabindex: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              !option.disabled &&
                                                _vm.selectItemHandler(option)
                                            },
                                            keyup: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                !option.disabled &&
                                                  _vm.selectItemHandler(option)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "down",
                                                    40,
                                                    $event.key,
                                                    ["Down", "ArrowDown"]
                                                  )
                                                )
                                                  return null
                                                return _vm.navigateDown($event)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "up",
                                                    38,
                                                    $event.key,
                                                    ["Up", "ArrowUp"]
                                                  )
                                                )
                                                  return null
                                                return _vm.navigateUp($event)
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _vm._t(
                                            "option",
                                            function () {
                                              return [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      option.displayText ||
                                                        option
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            },
                                            { option: option, index: index }
                                          ),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("options"),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        : [
            _c("div", { staticClass: "t-select__trigger" }, [
              _c(
                "select",
                {
                  ref: "select",
                  attrs: {
                    tabindex: "1",
                    name: _vm.name,
                    autofocus: _vm.autofocus,
                  },
                  domProps: { value: _vm.internalValue },
                  on: {
                    change: function ($event) {
                      return _vm.change($event)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.preventEvent.apply(null, arguments)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onEnter.apply(null, arguments)
                    },
                  },
                },
                _vm._l(_vm.options, function (option, index) {
                  return _c(
                    "option",
                    {
                      key: index,
                      staticClass: "t-select__item",
                      domProps: {
                        value: option.value || option,
                        selected: option.value == _vm.internalValue,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(option.displayText || option) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
      _vm._v(" "),
      _vm.invalidMessage
        ? _c("div", { staticClass: "t-select__error" }, [
            _vm._v("\n    " + _vm._s(_vm.invalidMessage) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "t-select__caption" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }